import CRVLogo from "../../assets/png/assets/CRV.png";
import WIFLogo from "../../assets/png/assets/WIF.png";
import AEVOLogo from "../../assets/svg/assets/AEVO.svg";
import ALTLogo from "../../assets/svg/assets/ALT.svg";
import APTLogo from "../../assets/svg/assets/APT.svg";
import ARLogo from "../../assets/svg/assets/AR.svg";
import ARBLogo from "../../assets/svg/assets/ARB.svg";
import ATOMLogo from "../../assets/svg/assets/ATOM.svg";
import AVAXLogo from "../../assets/svg/assets/AVAX.svg";
import AXLLogo from "../../assets/svg/assets/AXL.svg";
import BANANALogo from "../../assets/svg/assets/BANANA.svg";
import BEAMXLogo from "../../assets/svg/assets/BEAMX.svg";
import BITCOINLogo from "../../assets/svg/assets/BITCOIN.svg";
import BLASTLogo from "../../assets/svg/assets/BLAST.svg";
import BLURLogo from "../../assets/svg/assets/BLUR.svg";
import BLZLogo from "../../assets/svg/assets/BLZ.svg";
import BNBLogo from "../../assets/svg/assets/BNB.svg";
import BONKLogo from "../../assets/svg/assets/BONK.svg";
import BTCLogo from "../../assets/svg/assets/BTC.svg";
import CANTOLogo from "../../assets/svg/assets/CANTO.svg";
import DOGELogo from "../../assets/svg/assets/DOGE.svg";
import DYDXLogo from "../../assets/svg/assets/DYDX.svg";
import DYMLogo from "../../assets/svg/assets/DYM.svg";
import ETHLogo from "../../assets/svg/assets/ETH.svg";
import ETHFILogo from "../../assets/svg/assets/ETHFI.svg";
import ENALogo from "../../assets/svg/assets/ENA.svg";
import FALLBACKLogo from "../../assets/svg/assets/FALLBACK.svg";
import FRIENDLogo from "../../assets/svg/assets/FRIEND.svg";
import GLMRLogo from "../../assets/svg/assets/GLMR.svg";
import HIFILogo from "../../assets/svg/assets/HIFI.svg";
import ILVLogo from "../../assets/svg/assets/ILV.svg";
import INJLogo from "../../assets/svg/assets/INJ.svg";
import JITOLogo from "../../assets/svg/assets/JITO.svg";
import JUPLogo from "../../assets/svg/assets/JUP.svg";
import LDOLogo from "../../assets/svg/assets/LDO.svg";
import LINKLogo from "../../assets/svg/assets/LINK.svg";
import MANTALogo from "../../assets/svg/assets/MANTA.svg";
import MATICLogo from "../../assets/svg/assets/MATIC.svg";
import MEMELogo from "../../assets/svg/assets/MEME.svg";
import MINALogo from "../../assets/svg/assets/MINA.svg";
import MKRLogo from "../../assets/svg/assets/MKR.svg";
import MYROLogo from "../../assets/svg/assets/MYRO.svg";
import NEARLogo from "../../assets/svg/assets/NEAR.svg";
import NMRLogo from "../../assets/svg/assets/NMR.svg";
import NTRNLogo from "../../assets/svg/assets/NTRN.svg";
import OPLogo from "../../assets/svg/assets/OP.svg";
import ORDILogo from "../../assets/svg/assets/ORDI.svg";
import OXLogo from "../../assets/svg/assets/OX.svg";
import PARCLLogo from "../../assets/svg/assets/PARCL.svg";
import PENDLELogo from "../../assets/svg/assets/PENDLE.svg";
import PEPELogo from "../../assets/svg/assets/PEPE.svg";
import PIXELLogo from "../../assets/svg/assets/PIXEL.svg";
import PORTALLogo from "../../assets/svg/assets/PORTAL.svg";
import PRIMELogo from "../../assets/svg/assets/PRIME.svg";
import PYTHLogo from "../../assets/svg/assets/PYTH.svg";
import RNDRLogo from "../../assets/svg/assets/RNDR.svg";
import SATSLogo from "../../assets/svg/assets/SATS.svg";
import SEILogo from "../../assets/svg/assets/SEI.svg";
import SHFLLogo from "../../assets/svg/assets/SHFL.svg";
import SOLLogo from "../../assets/svg/assets/SOL.svg";
import STRAXLogo from "../../assets/svg/assets/STRAX.svg";
import STRKLogo from "../../assets/svg/assets/STRK.svg";
import SUILogo from "../../assets/svg/assets/SUI.svg";
import SYNLogo from "../../assets/svg/assets/SYN.svg";
import TLogo from "../../assets/svg/assets/T.svg";
import TAOLogo from "../../assets/svg/assets/TAO.svg";
import TIALogo from "../../assets/svg/assets/TIA.svg";
import TONLogo from "../../assets/svg/assets/TON.svg";
import TRBLogo from "../../assets/svg/assets/TRB.svg";
import TRXLogo from "../../assets/svg/assets/TRX.svg";
import UMALogo from "../../assets/svg/assets/UMA.svg";
import WLogo from "../../assets/svg/assets/W.svg";
import WLDLogo from "../../assets/svg/assets/WLD.svg";
import XRPLogo from "../../assets/svg/assets/XRP.svg";
import ZETALogo from "../../assets/svg/assets/ZETA.svg";
import USDCLogo from "../../assets/svg/assets/usdc.svg";
import USDTLogo from "../../assets/svg/assets/usdt.svg";
import SlerfLogo from "../../assets/png/assets/SLERF.png";

export type AssetResponse = string;
export type AssetInfoType = {
  [asset: AssetResponse]: {
    logo?: string;
    name?: string;
    description?: string;
  };
};

// The key eg. "ETH" MUST match the correct asset symbol returned from api
export const assets: AssetInfoType = {
  ETH: {
    logo: ETHLogo,
    name: "Ethereum",
    description:
      "Ethereum is a decentralized, open-source blockchain with smart contract functionality. Ether is the native cryptocurrency of the platform.",
  },
  BTC: {
    logo: BTCLogo,
    name: "Bitcoin",
    description:
      "Bitcoin is a decentralized digital currency, without a central bank or single administrator, that can be sent from user to user on the peer-to-peer bitcoin network. Bitcoin is the first and most widely recognized cryptocurrency.",
  },
  BNB: {
    logo: BNBLogo,
    name: "Binance Coin",
    description:
      "Binance Coin is a cryptocurrency issued by Binance Exchange, and trades with the BNB symbol. BNB was initially created on the Ethereum blockchain but has since become the native currency of the Binance Chain. Binance Coin has several use cases including trading fee discounts on the Binance Exchange.",
  },
  USDT: {
    logo: USDTLogo,
    name: "Tether",
    description:
      "Tether USD is a cryptocurrency stablecoin pegged to the U.S. dollar and backed '100% by Tether's reserves,' according to its website. Tether is owned by iFinex, the Hong Kong-registered company that also owns the crypto exchange BitFinex.",
  },
  USDC: {
    logo: USDCLogo,
    name: "USD Coin",
    description:
      "USDC is a stablecoin that is pegged to the U.S. dollar on a 1:1 basis. Every unit of this cryptocurrency in circulation is backed up by $1 that is held in reserve, in a mix of cash and short-term U.S. Treasury bonds. The Centre consortium, which is behind this asset, says USDC is issued by regulated financial institutions.",
  },
  MATIC: {
    logo: MATICLogo,
    name: "Polygon",
    description:
      "Polygon (Previously Matic Network) is the first well-structured, easy-to-use platform for Ethereum scaling and infrastructure development. Its core component is Polygon SDK, a modular, flexible framework that supports building multiple types of applications.",
  },
  XRP: {
    logo: XRPLogo,
    name: "Solana",
    description:
      "Ripple is a privately-held fintech company that provides a global payment solution via its patented payment network called Ripple Network (also known as RippleNet). Unlike most cryptocurrencies out there that cater to peer-to-peer needs, Ripple was made to connect banks, payment providers and digital asset exchanges, enabling real-time settlement expeditions and lower transaction fees.",
  },
  SOL: {
    logo: SOLLogo,
    name: "Ripple",
    description:
      "Solana is a Layer 1 blockchain that offers users fast speeds and affordable costs. It supports smart contracts and facilitates the creation of decentralized applications (dApps). Projects built on Solana include a variety of DeFi platforms as well as NFT marketplaces, where users can buy Solana-based NFT projects. Its high performance means Solana doesn’t require a traditional scaling Layer 2 solution; instead, Layer 2s on Solana focus on interoperability and connecting Solana to other chains.",
  },
  WLD: {
    logo: WLDLogo,
    name: "Worldcoin",
    description:
      "Worldcoin was founded with the mission of creating a globally-inclusive identity and financial network, owned by the majority of humanity. Worldcoin consists of a privacy-preserving digital identity network (World ID) built on proof of personhood and, where laws allow, a digital currency (WLD).",
  },
  CRV: {
    logo: CRVLogo,
    name: "Curve",
    description:
      "CRV is the governance token for Curve Finance. It implemented a complex time-based staking system to exchange CRV into veCRV, where veCRV is an internal token intended for governance purpose and has a right to claim the cash flows generated by the protocol.",
  },
  SEI: {
    logo: SEILogo,
    name: "SEI",
    description:
      "Sei is a general purpose, open-source Layer 1 blockchain specialized for for the exchange of digital assets. Leveraging a novel consensus and technical breakthroughs, Sei is the fastest blockchain in the industry.",
  },
  OX: {
    logo: OXLogo,
    name: "Open Exchange",
    description:
      "OX is the native fee paying, staking and governance token of OPNX.",
  },
  FRIEND: {
    logo: FRIENDLogo,
    name: "Friend",
    description:
      "FRIEND is a tradeable market for the market cap of accounts on friend.tech, a social tokenization protocol based on Coinbase’s Base L2. The platform empowers personalities, especially from platforms like X (formerly Twitter), to issue shares on its app, granting access to exclusive group chats.",
  },
  ARB: {
    logo: ARBLogo,
    name: "Arbitrum",
    description:
      "Arbitrum is a rollup chain, which is a layer 2 solution that aggregates and processes transactions off-chain, before submitting a single transaction to the Ethereum mainnet.",
  },
  OP: {
    logo: OPLogo,
    name: "Optimism",
    description:
      "Optimism is a rollup chain, which is a layer 2 solution that aggregates and processes transactions off-chain, before submitting a single transaction to the Ethereum mainnet.",
  },
  "1000PEPE": {
    logo: PEPELogo,
    name: "PEPE",
    description:
      "Pepe Coin, often referred to simply as Pepe by crypto and meme coin fans, was launched in late April 2023 as a tongue-in-cheek and humorous digital currency inspired by the popular internet meme Pepe the Frog.",
  },
  NMR: {
    logo: NMRLogo,
    name: "Numeraire",
    description:
      "Numeraire (NMR) is an ERC-20 token created by Numerai, a hedge fund company based in San Francisco. NMR is native to the Erasure Protocol, a decentralized prediction staking platform. On this prediction staking platform, NMR is rewarded in weekly tournament payouts for successful predictions while NMR staked is destroyed for unsuccessful predictions.",
  },
  SYN: {
    logo: SYNLogo,
    name: "Synapse",
    description:
      "Synapse (SYN) is an interoperability protocol designed for safely and securely sending arbitrary data between blockchains.",
  },
  BANANA: {
    logo: BANANALogo,
    name: "Banana Gun",
    description:
      "Banana Gun (BANANA) is a Telegram bot that allows you to snipe upcoming launches, or safely buy tokens that are already live.",
  },
  HIFI: {
    logo: HIFILogo,
    name: "Hifi",
    description:
      "Hifi Finance (HIFI) is a lending protocol that addresses the need for fixed-rate lending and borrowing in decentralized finance.",
  },
  MKR: {
    logo: MKRLogo,
    name: "Maker",
    description:
      "The Maker token (MKR) is a governance token that is used to govern and recapitalize the Maker protocol. Holders of the token can participate and vote on changes to the protocol’s smart contract and system parameters such as Stability Fees and the Dai Savings Rate (DSR).",
  },
  LINK: {
    logo: LINKLogo,
    name: "Link",
    description:
      "Chainlink is a decentralized oracle service. The LINK token is used to pay node operators for retrieving data for smart contracts and also for deposits placed by node operators as required by contract creators.",
  },
  GLMR: {
    logo: GLMRLogo,
    name: "Moonbeam",
    description:
      "Moonbeam is an Ethereum-compatible smart contract parachain on Polkadot. Moonbeam makes it easy to use popular Ethereum developer tools to build or redeploy Solidity projects in a Substrate-based environment.",
  },
  BLZ: {
    logo: BLZLogo,
    name: "Bluzelle",
    description:
      "Bluzelle is a decentralized storage network for the creator economy. Bluzelle delivers high security, un-matched availability, and is censorship resistant.",
  },
  TIA: {
    logo: TIALogo,
    name: "Celestia",
    description:
      "Celestia is a modular consensus and data network, built to enable anyone to easily deploy their own blockchain with minimal overhead.",
  },
  CANTO: {
    logo: CANTOLogo,
    name: "Canto",
    description:
      "Canto (CANTO) is a decentralized blockchain operating within the Cosmos ecosystem, emphasizing the accessibility and development of Decentralized Finance (DeFi). Launched in August 2022, it provides an open platform for DeFi initiatives, promoting transparency and decentralization.",
  },
  BITCOIN: {
    logo: BITCOINLogo,
    name: "HarryPotterObamaSonic10Inu (ETH)",
    description:
      "HarryPotterObamaSonic10Inu (Ticker: BITCOIN) is a crypto asset incentivizing unique meme content creation.",
  },
  AVAX: {
    logo: AVAXLogo,
    name: "AVAX",
    description:
      "Avalanche is a high throughput smart contract blockchain platform.",
  },
  DYDX: {
    logo: DYDXLogo,
    name: "DYDX",
    description:
      "dYdX is a governance token used to govern the dYdX Layer 2 exchange protocol to align incentives between traders, liquidity providers, and partners.",
  },
  T: {
    logo: TLogo,
    name: "T",
    description:
      "Threshold Network (T) is the on-chain merger between two existing networks (NU and KEEP). The platform is the only decentralized Bitcoin bridging protocol.",
  },
  STRAX: {
    logo: STRAXLogo,
    name: "STRAX",
    description:
      "The Stratis BaaS platform is designed for financial service providers and other enterprises to test, develop and deploy blockchain-based applications in a way that avoids the overhead and security concerns of operating their own networks.",
  },
  PRIME: {
    logo: PRIMELogo,
    name: "PRIME",
    description:
      "The Echelon Prime Foundation (EPF) is an ecosystem revolutionising game economies for players and builders. Parallel TCG — the first game to leverage Echelon’s tools — uses PRIME, an Ethereum token, to power unique in-game functions and companion apps.",
  },
  TRB: {
    logo: TRBLogo,
    name: "TRB",
    description:
      "Tellor is a transparent and permissionless oracle protocol for smart contracts to easily get any data whenever it needs it.",
  },
  INJ: {
    logo: INJLogo,
    name: "INJ",
    description:
      "Injective is the fastest blockchain built for finance and plug-and-play Web3 modules. It's ecosystem aims to reshape a broken financial system with dApps that are highly interoperable, scalable and truly decentralized.",
  },
  BLUR: {
    logo: BLURLogo,
    name: "BLUR",
    description:
      "Blur is a NFT marketplace where you can sweep NFTs across multiple marketplaces, snipe reveals faster than others, and manage your portfolio with advanced analytics.",
  },
  MINA: {
    logo: MINALogo,
    name: "MINA",
    description:
      "Mina is building a privacy and security layer for web3 with zero knowledge proofs.",
  },
  MEME: {
    logo: MEMELogo,
    name: "MEME",
    description:
      "Memecoin (MEME) is the native ecosystem token of Memeland. Memeland is the web3 venture studio by 9GAG, the globally popular meme platform.",
  },
  TAO: {
    logo: TAOLogo,
    name: "TAO",
    description:
      "Bittensor (TAO) is an open-source protocol that powers a decentralized, blockchain-based machine learning network.",
  },
  "1000BONK": {
    logo: BONKLogo,
    name: "BONK",
    description:
      "BONK is a decentralized cryptocurrency that was created on the Solana blockchain as the first dog-themed meme coin. It aims to be a fun and community-driven token that can be used across various dApps built on Solana.",
  },
  LDO: {
    logo: LDOLogo,
    name: "Lido DAO",
    description:
      "Lido DAO is a decentralized autonomous organization (DAO) which provides staking infrastructure for multiple blockchain networks.",
  },
  APT: {
    logo: APTLogo,
    name: "APTOS",
    description:
      "Aptos is a Layer 1 blockchain aiming to provide users with enhanced scalability, reliability, security, and usability.",
  },
  PYTH: {
    logo: PYTHLogo,
    name: "PYTH",
    description:
      "Pyth delivers real-time market data for crypto, equities, FX, and commodities to 40+ blockchains. 90+ major market participants — including Jane Street, CBOE, Binance, OKX, and Bybit — contribute data to the network.",
  },
  NTRN: {
    logo: NTRNLogo,
    name: "NTRN",
    description:
      "Powered by Tendermint and built with the Cosmos SDK, Neutron is the a secure permission-less smart contract platform for Interchain DeFi.",
  },
  DOGE: {
    logo: DOGELogo,
    name: "DOGE",
    description:
      'Dogecoin (DOGE) is based on the popular "doge" Internet meme and features a Shiba Inu on its logo.',
  },
  TRX: {
    logo: TRXLogo,
    name: "TRX",
    description:
      "TRON (TRX) is a decentralized blockchain-based operating system developed by the Tron Foundation and launched in 2017.",
  },
  BLAST: {
    logo: BLASTLogo,
    name: "BLAST",
    description:
      "BLAST is an upcoming Ethereum L2 with native yield for ETH and stablecoins. Since the tokenomics have not been released yet, this market assumes that there will be 1,000,000,000 tokens in circulation.",
  },
  BEAMX: {
    logo: BEAMXLogo,
    name: "BEAMX",
    description:
      "The $BEAM token (formerly MC) serves as the native crypto asset for the Beam network, a gaming network empowered by the Merit Circle DAO. Beam represents a collaborative platform where the gaming community, including players and developers, collaborates to drive the gaming sector's evolution.",
  },
  ILV: {
    logo: ILVLogo,
    name: "ILV",
    description:
      'Illuvium is an open-world, role-playing, NFT creature collector "play-to-earn" game running on the Ethereum blockchain. To power its economy, Illuvium uses its native ERC-20 token, $ILV.',
  },
  JUP: {
    logo: JUPLogo,
    name: "JUP",
    description:
      "As a liquidity aggregator on Solana, Jupiter aggregates the best token prices across different decentralized exchanges by connecting all DEX markets and AMM pools together, irrespective of the provider.",
  },
  RNDR: {
    logo: RNDRLogo,
    name: "RNDR",
    description:
      "RenderToken (RNDR) is a distributed GPU rendering network built on top of the Ethereum blockchain, aiming to connect artists and studios in need of GPU compute power with mining partners willing to rent their GPU capabilities out.",
  },
  ORDI: {
    logo: ORDILogo,
    name: "ORDI",
    description:
      "ORDI is the first token created in accordance with the BRC-20 fungible token standard on the Bitcoin blockchain.",
  },
  JITO: {
    logo: JITOLogo,
    name: "JITO",
    description:
      "Jito Foundation is launching a governance token aimed at both managing and spurring development of the Solana-based liquid staking protocol.",
  },
  "10000SATS": {
    logo: SATSLogo,
    name: "SATS",
    description:
      "Sats is a memecoin created on Bitcoin through the Ordinals protocol, named after ‘satoshis,’ the smallest unit of Bitcoin.",
  },
  ATOM: {
    logo: ATOMLogo,
    name: "ATOM",
    description:
      "The Cosmos network consists of many independent, parallel blockchains, called zones, each powered by classical Byzantine fault-tolerant (BFT) consensus protocols like Tendermint (already used by platforms like ErisDB).",
  },
  DYM: {
    logo: DYMLogo,
    name: "DYM",
    description:
      "Dymension is a modular blockchain platform with built-in roll-ups technology for scalability.",
  },
  MANTA: {
    logo: MANTALogo,
    name: "MANTA",
    description:
      "Manta Network is the plug-and-play privacy-preservation protocol built to service the entire DeFi stack.",
  },
  ALT: {
    logo: ALTLogo,
    name: "ALT",
    description:
      "AltLayer is a decentralized protocol that facilitates the launch of native and restaked rollups with both optimistic and zk rollup stacks.",
  },
  SUI: {
    logo: SUILogo,
    name: "SUI",
    description:
      "Sui is a first-of-its-kind Layer 1 blockchain and smart contract platform designed from the bottom up to make digital asset ownership fast, private, secure, and accessible to everyone.",
  },
  UMA: {
    logo: UMALogo,
    name: "UMA",
    description:
      "UMA is an optimistic oracle (OO) that can record any knowable truth onto a blockchain. It tells smart contracts “things about the world” so contracts and markets asking for that data can be settled.",
  },
  ZETA: {
    logo: ZETALogo,
    name: "ZETA",
    description:
      "ZetaChain is an EVM-compatible L1 blockchain that connects everything. Developers are able to build interoperable dApps that span any chain including Bitcoin.",
  },
  PIXEL: {
    logo: PIXELLogo,
    name: "PIXEL",
    description:
      "Pixels (PIXEL) is a social web3 game built on the Ronin Network.",
  },
  STRK: {
    logo: STRKLogo,
    name: "STRK",
    description:
      "StarkNet is a permissionless decentralized Validity-Rollup (also known as a “ZK-Rollup”). It operates as an L2 network over Ethereum, enabling any dApp to achieve unlimited scale for its computation – without compromising Ethereum’s composability and security, thanks to StarkNet’s reliance on the safest and most scalable cryptographic proof system – STARK.",
  },
  SHFL: {
    logo: SHFLLogo,
    name: "SHFL",
    description:
      "Shuffle is a leading crypto casino and sports betting platform launched in February 2023. SHFL will be tightly integrated with the core platform, reward the most active users, build the community, and take the player experience to new heights.",
  },
  PORTAL: {
    logo: PORTALLogo,
    name: "PORTAL",
    description:
      "$PORTAL is the native platform coin for the portal platform. $PORTAL acts as a nexus of web3 games and gamers, providing game distribution and player simplicity for all.",
  },
  PARCL: {
    logo: PARCLLogo,
    name: "PARCL",
    description:
      "Parcl is a decentralized real estate trading platform. Parcl offers city indexes that allow you to speculate on price movements of real estate markets across the globe.",
  },
  AR: {
    logo: ARLogo,
    name: "AR",
    description:
      "Arweave is a decentralized storage network that seeks to offer a platform for the indefinite storage of data.",
  },
  TON: {
    logo: TONLogo,
    name: "TON",
    description:
      "TON is a decentralized and open internet, created by the community using a technology designed by Telegram.",
  },
  AXL: {
    logo: AXLLogo,
    name: "AXL",
    description:
      "Axelar is the programmable Web3 interoperability platform, scaling the next generation of internet applications to billions of users.",
  },
  PENDLE: {
    logo: PENDLELogo,
    name: "PENDLE",
    description:
      "Pendle is a protocol that enables the tokenization and trading of future yield. With the creation of a novel AMM that supports assets with time decay, Pendle gives users more control over future yield by providing optionality and opportunities for its utilization.",
  },
  WIF: {
    logo: WIFLogo,
    name: "WIF",
    description: "Popular meme Dogwifhat vibes wif frens onchain",
  },
  MYRO: {
    logo: MYROLogo,
    name: "MYRO",
    description:
      "Myro the dog: Named after Solana Founder Raj Gokal’s dog Myro.",
  },
  W: {
    logo: WLogo,
    name: "W",
    description:
      "Wormhole is the leading interoperability platform powering multichain applications and bridges at scale — the Web of Web3.",
  },
  AEVO: {
    logo: AEVOLogo,
    name: "AEVO",
    description:
      "Aevo is the first Derivatives L2, focused on options & perps trading.",
  },
  NEAR: {
    logo: NEARLogo,
    name: "NEAR",
    description:
      "NEAR Protocol is a sharded, developer-friendly, proof-of-stake public blockchain, built by a world-class team that has built some of the world's only sharded databases at scale.",
  },
  ENA: {
    logo: ENALogo,
    name: "ENA",
    description:
      "Ethena is a synthetic dollar protocol built on Ethereum that will provide a crypto-native solution for money not reliant on traditional banking system infrastructure, alongside a globally accessible dollar denominated savings instrument - the 'Internet Bond'. The total supply is 15Bn ENA tokens.",
  },
  ETHFI: {
    logo: ETHFILogo,
    name: "ETHFI",
    description: "Native liquid restaking on Ethereum.",
  },
  SLERF: {
    logo: SlerfLogo,
    name: "Slerf",
    description: "The new sloth on the block.",
  },
};

export const getAssetInfo = (asset?: string) => {
  const info = asset ? assets[asset] : undefined;
  if (!info) {
    return {
      logo: FALLBACKLogo,
      name: asset,
      description: `${asset}`,
    };
  }
  return info;
};
